import { Box, createStyles, Flex, Input, Tabs, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdKeyboardArrowLeft } from "react-icons/md";
import DashboardDateComponent from "../../../components/DashboardDateComponent";
import { useDisclosure } from "@mantine/hooks";
import moment from "moment";
import { IconSearch } from "@tabler/icons-react";
import useDebounce from "../../../utils/useDebounce";
import CustomBillingPagination from "../../../components/Pagination/CustomBillingPagination";
import StaffAttendanceTable from "../../../components/StaffTable/StaffAttendanceTable";
import { getAllAttendenceStaff } from "../../../services/staff";
import { getAllFacilities } from "../../../services";
import AttendanceModal from "../../../containers/StaffModal/AttendanceModal";
import EvvRecordsTab from "../../../components/EvvRecords/EvvRecordsTab";
const useStyles = createStyles((theme) => ({
  content: {
    display: "flex",
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "#F5F5F5",
  },
  back: {
    cursor: "pointer",
    width: "fit-content",
  },
  headingText: {
    color: "#1D2939",
    fontFamily: "Inter",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    margin: "10px 20px",
  },
  subHeadingText: {
    color: "#171717",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    margin: "10px 20px",
  },
  table: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // height: "100vh",
    borderRadius: "12px",
    padding: "0 10px",
    background: "#FFFFFF",
    border: "1px solid #E5E5E5",
    margin: "10px 20px",
  },
  search: {
    // border: "1px solid #E5E5E5",
    background: "#FFF",
    // padding: "10px 0",
    margin: "10px 0",
    borderRadius: "12px",
  },
}));

export const StaffAttendance = () => {
  const { id } = useParams();
  const { profile } = useSelector((state) => state?.profile);
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [opened, { close, open }] = useDisclosure(false);
  const [dateRange, setDateRange] = useState({
    type: null,
    date: [
      moment().subtract(1, "month").startOf("day").toDate(),
      moment().endOf("day").toDate(),
    ],
  });
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 2000);
  const [currentPage, setCurrentPage] = useState(1);
  const [range, setRange] = useState([
    moment(dateRange?.date?.[0]),
    moment(dateRange?.date?.[1]),
  ]);
  const { staffCount } = useSelector((state) => state.staff);
  const [isStaffModalOpen, { open: openStaffModal, close: closeStaffModal }] =
    useDisclosure(false);
  const [refresh, setRefresh] = useState(false);
  const [selectedItem, setSelectedItem] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mode, setmode] = useState("view");

  const location = useLocation();

  // useEffect(() => {
  //   setRange(() =>{
  //     let f = moment(dateRange?.date?.[0])
  //     let t = moment(dateRange?.date?.[1])

  //     return [f,t]
  //   })
  // }, []);

  useEffect(() => {
    attendenceStaff();
  }, [currentPage, debouncedSearch, range, refresh]);

  const attendenceStaff = async () => {
    try {
      setLoading(true);
      await getAllAttendenceStaff(currentPage, range, debouncedSearch);
    } catch (e) {
      console.log("🚀 ~ attendenceStaff ~ e:", e);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   getAllFacilities();
  // }, []);

  const handleApply = () => {
    setRange(() => {
      let f = moment(dateRange?.date?.[0]);
      let t = moment(dateRange?.date?.[1]);

      return [f, t];
    });
    close();
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowClick = (row, trackId, edit) => {
    // setOpen(true)
    setSelectedItem({ id: row, trackId });
    setmode(edit || "view");
    openStaffModal(edit || mode);
  };

  // useEffect(() => {
  //   if (debouncedSearch) {
  //     getTodaysNotes(debouncedSearch);
  //   } else {
  //     getTodaysNotes("");
  //   }
  // }, [debouncedSearch, getTodaysNotes]);

  return (
    <Box fluid className={classes.content}>
      <AppNavbar title={`Staff`} profile={profile} />
      <Flex
        align="center"
        gap={5}
        m={10}
        onClick={() => navigate("/home/staff")}
        className={classes.back}
      >
        <MdKeyboardArrowLeft size={30} />
        <Text fw={400} fz={12} c={"#262626"} ff={"Inter"}>
          Back
        </Text>
      </Flex>
      <Text className={classes.headingText}>Attendance</Text>
      <Flex align="center" justify="space-between" gap={5} m={10}>
        <Text className={classes.subHeadingText}>
          {id === "all" ? "All Staff" : ""}
        </Text>
        <DashboardDateComponent
          dateRange={dateRange}
          setDateRange={setDateRange}
          handleApply={handleApply}
          open={open}
          opened={opened}
          close={close}
        />
      </Flex>

      <Box mx={20}>
        <Tabs defaultValue="attendance">
          <Tabs.List>
            <Tabs.Tab value="attendance">Attendance</Tabs.Tab>
            <Tabs.Tab value="evv-records">EVV Records</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="attendance" pt="sm">
            <Box className={classes.table} style={{ margin: 0 }}>
              {id === "all" ? (
                <Box className={classes.search}>
                  <Input
                    radius={"md"}
                    icon={<IconSearch />}
                    placeholder="Search Staff Name"
                    className={classes.searchInput}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </Box>
              ) : (
                <Box mt={10}></Box>
              )}
              <StaffAttendanceTable
                staff={id}
                handleRowClick={handleRowClick}
                loading={loading}
                range={range}
                debouncedSearch={debouncedSearch}
              />

              {location.pathname === "/home/staff/manage-attendance/all" && (
                <CustomBillingPagination
                  data={staffCount}
                  itemsPerPage={10}
                  currentPage={currentPage}
                  handlePageChange={handlePageChange}
                />
              )}
            </Box>
          </Tabs.Panel>

          <Tabs.Panel value="evv-records" pt="sm">
            <Box className={classes.table} style={{ margin: 0 }}>
              <EvvRecordsTab range={range} />
            </Box>
          </Tabs.Panel>
        </Tabs>
      </Box>

      <AttendanceModal
        mode={mode}
        title={
          mode === "edit" ? "Edit Time & Attendance" : "View Time & Attendance"
        }
        opened={isStaffModalOpen}
        onclose={closeStaffModal}
        selectedItem={selectedItem.id}
        trackId={selectedItem.trackId}
        currentPage={currentPage}
      />
    </Box>
  );
};
